import { render, staticRenderFns } from "./ProjectJournalsTTableStudentRow.vue?vue&type=template&id=3a6c7f1a&scoped=true&"
import script from "./ProjectJournalsTTableStudentRow.vue?vue&type=script&lang=ts&"
export * from "./ProjectJournalsTTableStudentRow.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectJournalsTTableStudentRow.vue?vue&type=style&index=0&id=3a6c7f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c7f1a",
  null
  
)

export default component.exports